/**
 * ViaCEP API utility
 * Busca endereço brasileiro pelo CEP usando a API gratuita do ViaCEP
 */

export interface ViaCepResponse {
    cep: string;
    logradouro: string;
    complemento: string;
    bairro: string;
    localidade: string;
    uf: string;
    ibge: string;
    gia: string;
    ddd: string;
    siafi: string;
    erro?: boolean;
}

export interface AddressData {
    cep: string;
    street: string;
    neighborhood: string;
    city: string;
    state: string;
}

/**
 * Busca endereço pelo CEP usando ViaCEP API
 * @param cep - CEP no formato 00000-000 ou 00000000
 * @returns Dados do endereço ou null se não encontrado
 */
export async function fetchAddressByCep(cep: string): Promise<AddressData | null> {
    // Remove caracteres não numéricos
    const cleanCep = cep.replace(/\D/g, '');

    if (cleanCep.length !== 8) {
        return null;
    }

    try {
        const response = await fetch(`https://viacep.com.br/ws/${cleanCep}/json/`);

        if (!response.ok) {
            console.error('[ViaCEP] Erro na requisição:', response.status);
            return null;
        }

        const data: ViaCepResponse = await response.json();

        if (data.erro) {
            console.warn('[ViaCEP] CEP não encontrado:', cleanCep);
            return null;
        }

        return {
            cep: data.cep,
            street: data.logradouro,
            neighborhood: data.bairro,
            city: data.localidade,
            state: data.uf
        };
    } catch (error) {
        console.error('[ViaCEP] Erro ao buscar CEP:', error);
        return null;
    }
}

/**
 * Formata CEP para o padrão 00000-000
 */
export function formatCep(cep: string): string {
    const cleanCep = cep.replace(/\D/g, '');
    if (cleanCep.length <= 5) return cleanCep;
    return `${cleanCep.slice(0, 5)}-${cleanCep.slice(5, 8)}`;
}
